import React from 'react';
import Container from '@mui/material/Container';

import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: "#0077C8"
    },
    secondary: {
      main: "#4D4D4F"
    },
  },
});

function LoginCallback() {
  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth={false} disableGutters sx={{ overflowX: 'hidden' }}>
      </Container>
    </ThemeProvider>
  );
}

export default LoginCallback;
